module.exports = __webpack_public_path__ + "static/media/ZapytanieOfertowe3.ecd4aaa5.pdf";